// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var CustomerController = function ($scope, $routeParams, $window, Customer, ContractByCustomer, Contract, Plan, LedgerEntryByCustomer, gettext,
    gettextCatalog, CustomFieldSettings, LedgerUtils, LockStateUpdater, EuropeanUnion, InvoiceAttachmentDisplayFormats, GeneralEmailSettings) {
    const lifecycleStatusEnum = {
        Undefined: 'Undefined',
        Active: 'Active',
        Draft: 'Draft',
        Annulled: 'Annulled',
        InOrderProcess: 'InOrderProcess',
        InTrial: 'InTrial',
        TrialExpired: 'TrialExpired',
        Ended: 'Ended',
        TemporarilyInactive: 'TemporarilyInactive',
        Locked: 'Locked',
        Cancelled: 'Cancelled',
        WrittenOff: 'WrittenOff'
    };

    $scope.zugFerdFeature = "ZugferdV1";
    $scope.eInvoicingFeature = "EInvoicingEcosio";
    $scope.invoiceAttachmentDisplayFormat = null;

    $scope.popoverText = {
        description:
            gettext("VatID validation skipped: reverse charge not applied.")
          }

    $scope.LifecycleStatusEnum = lifecycleStatusEnum;

    $scope.customer = Customer.get({ customerId: $routeParams.customerId },
        function (data) {
            if (data.AdditionalEmailAddresses) {
                data.AdditionalEmailAddresses = data.AdditionalEmailAddresses.map(function (emailAddressAssignment) { return emailAddressAssignment.EmailAddress}).join(', ');
            }
            GeneralEmailSettings.get({}, function(generalData) {
                $scope.getinvoiceAttachmentDisplayFormat(generalData.InvoiceAttachmentFormat);
            });
        });

    $scope.contracts = $scope.paginator(function (options, callback) {
        return ContractByCustomer.query(options, function (data) {
            callback();
        });
    }, {customerId: $routeParams.customerId}, 100);
    
    $scope.plansById = {};
    CustomFieldSettings.get({}, function (data) {
        $scope.customFieldSettings = data.CustomFieldDescriptors;
    });

    $scope.getinvoiceAttachmentDisplayFormat = function(generalInvoiceAttachmentFormat)
    {
        if ($scope.features[$scope.zugFerdFeature]) {
            var formats = InvoiceAttachmentDisplayFormats.getFormats();
            var formatType = $scope.customer.InvoiceAttachmentFormat
                ? $scope.customer.InvoiceAttachmentFormat
                : generalInvoiceAttachmentFormat;

            for (var i = 0; i < formats.length; i++) {
                if (formatType === formats[i].type) {
                    $scope.invoiceAttachmentDisplayFormat = formats[i].displayName;
                }
            }
        }
    }
    
    GeneralEmailSettings.get({ }, function (settings) { $scope.generalInvoiceFormat = settings.InvoiceAttachmentFormat; });
    $scope.canShowBuyerReference = function(isZugFerdActive, invoiceAttachmentDisplayFormat, isEcosioActive) {
        let referenceEnabled = Customer.canShowBuyerReference(isZugFerdActive, invoiceAttachmentDisplayFormat, isEcosioActive);
        if(isEcosioActive)
            return referenceEnabled;
        return $scope.customer.BuyerReference && referenceEnabled;
    };

    $scope.plans = Plan.query({}, function () {
        for (var i = 0; i < $scope.plans.length; i++) {
            $scope.plansById[$scope.plans[i].Id] = $scope.plans[i];
        }
    });

    $scope.ledgerEntries = $scope.paginator(function (options, callback) {
        return LedgerEntryByCustomer.query(options, function (data) {
            callback();
            LedgerUtils.populateAdditionalDetails($scope.ledgerEntries.items);
            $scope.$digest();
        });
    }, { customerId: $routeParams.customerId }, 100);

    $scope.deleteContract = function (contractId) {
        $scope.yesCancel(gettextCatalog.getString(gettext('Delete Contract')), gettextCatalog.getString(gettext('Are you sure?')), function () { 
            Contract.remove({ contractId: contractId }, function () {
                if ($scope.contracts.isFirst) {
                    $scope.contracts.first();
                } else {
                    $scope.contracts.prev();
                }
            }); 
        });
    };

    $scope.getReference = function (contractId) {
        for (var i = 0; i < $scope.contracts.items.length; i++) {
            if (contractId === $scope.contracts.items[i].Id) return $scope.contracts.items[i].ReferenceCode;
        }
    };

    $scope.back = function () {
        $window.history.back();
    };

    $scope.updateLockedState = function () {
        var updateLockedStateCallback = function () {
            var successCallback = function () {
                $window.location.reload();
            };

            LockStateUpdater.updateLockedState($scope.customer.Id, !$scope.customer.IsLocked, successCallback);
        };

        var title = $scope.customer.IsLocked ? gettextCatalog.getString(gettext('Before you unlock the customer, please note:')) : gettextCatalog.getString(gettext('Before you lock the customer, please note:'));
        $scope.customPopup(title, $scope.customer.IsLocked ? 'partials/controls/customer-unlock-modal-body.html' : 'partials/controls/customer-lock-modal-body.html', updateLockedStateCallback);
    };

    $scope.GetCurrentPhaseIndex = function(contract) {
        var currentPhaseIndex = -1;
        for (var i = 0; i < contract.Phases.length; i++) {
            if (contract.Phases[i].StartDate === contract.CurrentPhase.StartDate &&
                contract.Phases[i].Type === contract.CurrentPhase.Type) {
                currentPhaseIndex = i;
                break;
            }
        }

        return currentPhaseIndex;
    }

    $scope.GetPrevPlanName = function (contract) {
        try {
            var currentPhaseIndex = $scope.GetCurrentPhaseIndex(contract);

            if (currentPhaseIndex <= 0) {
                return undefined;
            }

            return $scope.plansById[contract.Phases[currentPhaseIndex - 1].PlanId].Name;
        }
        catch(e) {
            return undefined;
        }
    };
};
CustomerController.$inject = ['$scope', '$routeParams', '$window', 'Customer', 'ContractByCustomer', 'Contract', 'Plan', 'LedgerEntryByCustomer', 'gettext',
    'gettextCatalog', 'CustomFieldSettings', 'LedgerUtils', 'LockStateUpdater', 'EuropeanUnion', 'InvoiceAttachmentDisplayFormats', 'GeneralEmailSettings'];
